<!-- Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. -->
<ng-container *ngIf="importResults$ | async as importResults">
	<div mat-dialog-content *ngIf="!importResults.errorDescription; else importError">
		<p>{{ appStrings.IMPORT_TICKET_RESULTS_SUCCESS_TITLE }}</p>
		<p *ngIf="importResults.tickets || importResults.dependencies">
			<span *ngIf="importResults.tickets?.created || importResults.tickets?.updated" class="result-line">{{
				appStrings.IMPORT_TICKET_RESULTS_TICKETS_CREATED_UPDATED(
					importResults.tickets?.created,
					importResults.tickets?.updated
				)
			}}</span>
			<span *ngIf="importResults.dependencies?.created" class="result-line">{{
				appStrings.IMPORT_TICKET_RESULTS_DEPENDENCIES_CREATED(importResults.dependencies?.created)
			}}</span>
			<span *ngIf="importResults.dependencies?.notCreated" class="result-line">{{
				appStrings.IMPORT_TICKET_RESULTS_DEPENDENCIES_NOT_CREATED(importResults.dependencies?.notCreated)
			}}</span>
		</p>
		<p *ngIf="importResults.snapshotId">
			{{ appStrings.IMPORT_TICKET_RESULTS_SUCCESS_REVIEW_RESULTS(importResults.snapshotId) }}
		</p>
	</div>

	<mat-divider class="padded-divider"></mat-divider>

	<div mat-dialog-actions class="import-tickets-result-dialog-footer">
		<button type="button" mat-raised-button mat-dialog-close color="primary" automationId="cancel">
			{{ appStrings.UICONTROL_TEXT_CLOSE.toUpperCase() }}
		</button>
	</div>
</ng-container>

<ng-template #importError>
	<div mat-dialog-content>
		<p>{{ appStrings.IMPORT_TICKET_RESULTS_FAILURE_TITLE }}</p>
		<p>{{ appStrings.IMPORT_TICKET_RESULTS_FAILURE_IMPORT_INCOMPLETE }}</p>
		<p>{{ appStrings.IMPORT_TICKET_RESULTS_FAILURE_PLAN_UNMODIFIED }}</p>
	</div>
</ng-template>
